import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { Device, until } from '@helpers/media';
import useMedia from '@hooks/useMedia';
import { FocusRing, useFocusManager } from '@react-aria/focus';
import * as React from 'react';
import { useFirstMountState } from 'react-use';
import S from '../Accordion.styles';
import { useAccordion } from '../Context/Context';
const AccordionItem = (props) => {
    const isFirstMount = useFirstMountState();
    const isMobile = useMedia([until(Device.TabletLarge)], [true], false);
    const accordion = useAccordion();
    const fm = useFocusManager();
    const isActive = accordion.activeId === props.id;
    const headerId = `${props.id}-header`;
    const bodyId = `${props.id}-body`;
    // Scroll to active question
    React.useEffect(() => {
        if (isFirstMount) {
            return;
        }
        setTimeout(() => {
            if (!isActive || !isMobile) {
                return;
            }
            const el = document.getElementById(headerId);
            if (el) {
                const top = el.getBoundingClientRect().top +
                    window.scrollY -
                    (document.getElementById('header')?.clientHeight ?? 0);
                window.scrollTo({ top: top - 32, left: 0, behavior: 'smooth' });
            }
        }, 350);
    }, [isActive]);
    return (React.createElement(S.Item, { initial: isActive ? 'opened' : 'closed', animate: isActive ? 'opened' : 'closed', onKeyDown: (event) => {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    event.stopPropagation();
                    fm?.focusNext();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    event.stopPropagation();
                    fm?.focusPrevious();
                    break;
                case 'Home':
                    event.preventDefault();
                    event.stopPropagation();
                    fm?.focusFirst();
                    break;
                case 'End':
                    event.preventDefault();
                    event.stopPropagation();
                    fm?.focusLast();
                    break;
                default:
                    break;
            }
        } },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.ItemHeader, { id: headerId, "aria-controls": bodyId, "aria-expanded": isActive, type: "button", onClick: (event) => {
                    event.preventDefault();
                    accordion.onClick(props.id);
                } },
                React.createElement(S.ItemTitle, null, props.title),
                React.createElement(S.ItemIcon, { "aria-hidden": "true", variants: {
                        closed: {
                            rotate: 0,
                        },
                        opened: {
                            rotate: 180,
                        },
                    } }, getSystemIcon(SystemIcon.ChevronDown)))),
        React.createElement(S.ItemBody, { id: bodyId, "aria-labelledby": headerId, role: "region", variants: {
                closed: {
                    height: 0,
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                },
                opened: {
                    visibility: 'visible',
                    height: 'auto',
                },
            } }, props.children)));
};
export default AccordionItem;
